import { Injectable } from "@angular/core";
import { environment } from "app/environments/environment";

type LogLevel = "debug" | "info" | "warn" | "error";

@Injectable({ providedIn: "root" })
export class LoggerService {
  private currentLogLevel: LogLevel = environment.production ? "warn" : "debug";
  private prodMode = environment.production;

  setLogLevel(level: LogLevel): void {
    this.currentLogLevel = level;
  }

  debug(context: string, message: string, ...meta: any[]): void {
    this.log("debug", context, message, meta);
  }

  info(context: string, message: string, ...meta: any[]): void {
    this.log("info", context, message, meta);
  }

  warn(context: string, message: string, ...meta: any[]): void {
    this.log("warn", context, message, meta);
  }

  error(context: string, message: string, ...meta: any[]): void {
    this.log("error", context, message, meta);
  }

  private log(
    level: LogLevel,
    context: string,
    message: string,
    meta: any[]
  ): void {
    if (this.prodMode && (level === "debug" || level === "info")) return;
    if (!this.shouldLog(level)) return;

    const timestamp = new Date().toISOString();
    const logEntry = `[${timestamp}] [${level.toUpperCase()}] [${context}] ${message}`;

    switch (level) {
      case "debug":
        console.debug(logEntry, ...meta);
        break;
      case "info":
        console.info(logEntry, ...meta);
        break;
      case "warn":
        console.warn(logEntry, ...meta);
        break;
      case "error":
        console.error(logEntry, ...meta);
        break;
    }
  }

  private shouldLog(level: LogLevel): boolean {
    const levels: LogLevel[] = ["debug", "info", "warn", "error"];
    return levels.indexOf(level) >= levels.indexOf(this.currentLogLevel);
  }
}
